module.exports = __webpack_public_path__ + "img/sbl-xc.1f77f839.png";